/**
 * Utilitário para mapear comentários da API para o formato esperado pelo frontend
 */
import { Comentario, Usuario, TipoUsuario } from '../../types';

export interface ComentarioAPI {
  id: string;
  texto: string;
  data_criacao: string;
  usuario_id: string;
  usuario_nome: string;
  usuario_email: string;
  usuario_avatar: string;
}

/**
 * Mapeia um comentário da API para o formato esperado pelo frontend
 */
export const mapearComentario = (comentario: ComentarioAPI): Comentario => {
  return {
    id: comentario.id,
    texto: comentario.texto,
    dataCriacao: comentario.data_criacao,
    usuario: {
      id: comentario.usuario_id,
      nome: comentario.usuario_nome,
      email: comentario.usuario_email,
      avatar: '/profilepicture.png', // Usando imagem padrão
      cargo: '',
      departamentoId: '',
      ehLider: false,
      tipo: 'comum' as TipoUsuario,
      tarefasAtivas: 0,
      tarefasConcluidas: 0,
      dataCriacao: ''
    }
  };
};

/**
 * Mapeia uma lista de comentários da API para o formato esperado pelo frontend
 */
export const mapearComentarios = (comentarios: ComentarioAPI[] = []): Comentario[] => {
  return comentarios.map(mapearComentario);
};
